export class SortingSettingsTaskModel {
  OrderDescendingByTaskId?: boolean = false;
  OrderDescendingByName?: boolean = false;
  OrderDescendingByEstimates?: boolean = false;
  OrderDescendingBySpent?: boolean = false;
  constructor(obj?: Partial<SortingSettingsTaskModel>) {
    if (obj) {
      Object.assign(this, obj);
    }
  }
}
